export default __webpack_public_path__ + "static/media/kevin_champs-elysees.74722605.jpg";